import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddElementPlaceholderComponent } from '@shared/components/add-element-placeholder/add-element-placeholder.component';
import { LoaderPulseComponent, LoaderSpinnerComponent } from '@shared/components/loaders';
import { TextLabelComponent, TextValueComponent } from '@shared/components/text';
import { KeysPipe } from '@shared/pipes/keys.pipe';
import { SafePipe } from '@shared/pipes/safe.pipe';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AlertComponent } from './components/alert/alert.component';
import { ContentHelperComponent } from './components/content-helper/content-helper.component';
import { DateInfoPresenterComponent } from './components/date-info-presenter/date-info-presenter.component';
import { DividerComponent } from './components/divider/divider.component';
import { ListItemComponent } from './components/list/list-item/list-item.component';
import { ListComponent } from './components/list/list.component';
import { LoaderSmallComponent } from './components/loaders/loader-small/loader-small.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { PanelBodyComponent } from './components/panel/panel-body/panel-body.component';
import { PanelHeaderComponent } from './components/panel/panel-header/panel-header.component';
import { PanelComponent } from './components/panel/panel.component';
import { SectionContentComponent } from './components/section/section-content/section-content.component';
import { SectionDescriptionComponent } from './components/section/section-description/section-description.component';
import { SectionTitleComponent } from './components/section/section-title/section-title.component';
import { SectionComponent } from './components/section/section.component';

@NgModule({
  declarations: [
    PageTitleComponent,
    PanelComponent,
    PanelHeaderComponent,
    PanelBodyComponent,
    SectionTitleComponent,
    SectionContentComponent,
    SectionComponent,
    ListComponent,
    ListItemComponent,
    ContentHelperComponent,
    LoaderSpinnerComponent,
    LoaderPulseComponent,
    DateInfoPresenterComponent,
    KeysPipe,
    SafePipe,
    LoaderSmallComponent,
    TextLabelComponent,
    TextValueComponent,
    AlertComponent,
    AddElementPlaceholderComponent,
    SectionDescriptionComponent,
    DividerComponent,
  ],
  imports: [
    CommonModule,
    NgScrollbarModule,
  ],
  exports: [
    PageTitleComponent,
    PanelComponent,
    PanelHeaderComponent,
    PanelBodyComponent,
    SectionComponent,
    SectionTitleComponent,
    SectionContentComponent,
    ListComponent,
    ListItemComponent,
    ContentHelperComponent,
    DateInfoPresenterComponent,
    KeysPipe,
    SafePipe,
    LoaderSmallComponent,
    LoaderPulseComponent,
    TextLabelComponent,
    TextValueComponent,
    AlertComponent,
    AddElementPlaceholderComponent,
    SectionDescriptionComponent,
    DividerComponent,
  ]
})
export class SharedModule {
}
